import HeroBg from "public/vulnerabilityPatchmngmt/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Streamline Compliance & SEC Ops ",
    link: "contact-us",
  },
  title: " Fix Security Gaps Before They’re Exploited ",
  desc: " Identify, prioritize, and remediate vulnerabilities across your infrastructure — automatically and at scale.",
  image: HeroBg,
};
